import { useDispatch } from 'react-redux';
import {
  openCheckoutModal,
  setCheckoutPlans,
  setFullPageLoader,
} from '../../store/reducers';
import { ANALYTICS } from '../../constants/analytics/analytics';
import { apiPremium } from '../../utils/api/apiPremium';
import { ECheckoutSource, IPlan } from '../../models/checkout.model';

interface OpenPremiumOptions {
  readonly source: string;
  readonly loginSource?: string;
  readonly checkoutSource?: ECheckoutSource;
  readonly plans?: IPlan[];
  readonly successRedirectUrl?: string;
}

export const usePremium = () => {
  const dispatch = useDispatch();

  const openPremium = async (options: OpenPremiumOptions): Promise<void> => {
    const {
      source,
      loginSource = ANALYTICS.VALUES.CHECKOUT_MODAL,
      checkoutSource = ECheckoutSource.premiumModal,
      plans: providedPlans,
      successRedirectUrl,
    } = options;

    dispatch(setFullPageLoader(true));

    const plans =
      providedPlans ?? (await apiPremium.getSubscriptionPlans(checkoutSource));

    // If plans failed to load (null), handle gracefully
    if (!plans || plans.length === 0) {
      dispatch(setFullPageLoader(false));
      // Don't open modal if no plans available
      return;
    }

    dispatch(setCheckoutPlans(plans));
    dispatch(
      openCheckoutModal({
        source,
        loginSource,
        successRedirectUrl,
      })
    );
  };

  return { openPremium };
};
